import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import {
  getVisualisationTypesForGroupByField,
  isAggregateFormula,
} from '@modules/quantify/utils';
import { EqlField, QuantifyVisualisationType } from 'generated/graphql';

export function useGetRelevantVisualisationType() {
  const shouldSkipTrendChart = useQuantifyStore(
    ({ visual }) => visual.shouldSkipTrendChart,
  );

  const currentVisualisationType = useQuantifyStore(
    ({ query }) => query.visualisationType,
  );

  const shouldSkipPieChart = useQuantifyStore(({ query }) =>
    isAggregateFormula(query.formulaQuery?.eqlFunction),
  );

  return ({
    eqlField,
    measuredAsCriteria,
  }: {
    eqlField: EqlField;
    measuredAsCriteria?: EqlField;
  }) => {
    const visualisationTypes = getVisualisationTypesForGroupByField({
      groupBy: eqlField,
      skipPieChart: shouldSkipPieChart,
      skipTrendChart: shouldSkipTrendChart,
      measuredAsCriteria,
    });

    return currentVisualisationType &&
      visualisationTypes.includes(currentVisualisationType)
      ? currentVisualisationType
      : QuantifyVisualisationType.Bar;
  };
}
